import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from 'components/Chart/DateGroupSwitcher/ChartSettings.module.scss'
import { Grid, Typography } from 'gu-ui-kit'
import clsx from 'clsx'

const ChartSettings = ({
  className,
  handleClick = () => {},
  dateGroupPeriod = { value: '', options: [] },
}) => {
  const { t } = useTranslation(['pulse'])

  return (
    <Grid
      gap={16}
      wrap={'nowrap'}
      direction={'row'}
      className={className}
    >
      {dateGroupPeriod.options.map((period) => (
        <Typography
          noMargin
          variant={'Body-20'}
          key={period}
          className={clsx(styles['chart-settings__tabs-item'], {
            [styles['chart-settings__tabs-item_active']]: dateGroupPeriod.value === period,
          })}
        >
          <Typography
            variant={'Body-Forms-20'}
            className={styles['chart-settings__tabs-link']}
            onClick={() => handleClick(period)}
          >
            {t(`date_group_period.labels.${period}`)}
          </Typography>
        </Typography>
      ))}
    </Grid>
  )
}

export default ChartSettings

ChartSettings.defaultProps = {
  className: '',
  handleClick: () => {},
}

ChartSettings.propTypes = {
  className: PropTypes.string,
  handleClick: PropTypes.func,
  dateGroupPeriod: PropTypes.object,
}
